import React from 'react';

import { getLayout } from 'components/layouts/Header';
import { Page } from 'components/layouts';
import { SearchBar, SearchContent, NonOnboardedUserBanner, PageHeadMeta } from 'components/search/results';
import { GlobalSearchProvider, useGlobalSearch } from 'lib/providers/GlobalSearchProvider';
import { useAuth } from 'lib/providers/AuthProvider';
import { GlobalSearchDataProvider } from 'lib/providers/GlobalSearchDataProvider';
import { CandidateProfileProvider } from 'lib/contexts/candidate-profile-context';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';
import { SearchPageType } from 'lib/utils/global.search';
import { TQueryParams } from 'utils/search';

import styles from './SearchResults.module.scss';

const SearchResultsContent: React.FC<{ pageTitle?: string }> = ({ pageTitle }) => {
  const { isNonOnboardedUser } = useAuth();
  const { type, canShowOnboardingBanner } = useGlobalSearch();

  return (
    <GlobalSearchDataProvider type={type} pageTitle={pageTitle}>
      <SearchBar />
      {isNonOnboardedUser && canShowOnboardingBanner && <NonOnboardedUserBanner />}
      <CandidateProfileProvider>
        <SearchContent />
      </CandidateProfileProvider>
    </GlobalSearchDataProvider>
  );
};

const SearchResults: React.FC<{ requestedPageType: SearchPageType | null; pageHead?: JSX.Element; pageTitle?: string; queryParams: TQueryParams }> =
  ({ requestedPageType, pageHead, pageTitle, queryParams }) => {
    return (
      <GlobalSearchProvider requestedPageType={requestedPageType} initialQueryParams={queryParams}>
        <PageHeadMeta initialPageHead={pageHead} />
        <Page className={styles.container}>
          <SearchResultsContent pageTitle={pageTitle} />
        </Page>
      </GlobalSearchProvider>
    );
  };

export async function getServerSideProps(context: { locale: string; query: { type?: string } }) {
  const {
    locale,
    query: { type = null },
  } = context;

  return {
    props: {
      requestedPageType: type,
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.SEARCH_RESULTS, LOCALE_PAGES.OPPORTUNITY],
      })),
    },
  };
}

// @ts-ignore
SearchResults.getLayout = getLayout;

export default SearchResults;
